import wx from 'weixin-js-sdk';
export default {

  wxShowMenu: function (mesData, LTtitle, LTimg, LTcontent, PYQtitle, PYQimg, PYQcontent) {

    let myLTtitle = LTtitle || "欢迎"; //分享到聊天框       
    let myLTimg = LTimg || "../assets/logo01.jpg"; //分享到聊天框     
    let myLTcontent = LTcontent || ""; //分享到聊天框          

    let myPYQtitle = PYQtitle || "欢迎"; //分享到朋友圈（朋友圈描述无效，所以直接拼接到标题上）
    if (PYQcontent) {
      myPYQtitle = myPYQtitle + ' | ' + PYQcontent;
    }
    let myPYQimg = PYQimg || "../assets/logo01.jpg"; //分享到朋友圈 

    let shareWxLink = window.location.href; //分享链接
    console.log(`
      聊天标题：${myLTtitle}
      聊天图片：${myLTimg}
      聊天介绍：${myLTcontent}
      聊天链接：${shareWxLink}
      朋友圈标题：${myPYQtitle}
      朋友圈图片：${myPYQimg}
      朋友圈介绍：朋友圈描述无效，所以直接拼接到标题上
      朋友圈链接：${shareWxLink} 
      `);
    let getMsg = mesData;
    wx.config({

      debug: false, //生产环境需要关闭debug模式

      appId: getMsg.appId, //appId通过微信服务号后台查看

      timestamp: getMsg.timestamp, //生成签名的时间戳

      nonceStr: getMsg.nonceStr, //生成签名的随机字符串

      signature: getMsg.signature, //签名

      jsApiList: [ //需要调用的JS接口列表

        'updateAppMessageShareData', //分享给好友

        'updateTimelineShareData', //分享到朋友圈

        'onMenuShareTimeline',

        'onMenuShareAppMessage',

      ],

    });
    wx.ready(function () {

      wx.checkJsApi({

        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage', ], //分享到朋友圈,
        success: function (res) {
          console.log(res);
        }

      });
      if (wx.onMenuShareAppMessage) {
        wx.onMenuShareAppMessage({

          title: myLTtitle, // 分享标题

          desc: myLTcontent, //分享描述

          link: shareWxLink, // 分享链接

          imgUrl: myLTimg // 分享图标

        });
        wx.onMenuShareTimeline({

          title: myPYQtitle, // 分享标题

          desc: '', //分享描述

          link: shareWxLink, // 分享链接

          imgUrl: myPYQimg // 分享图标

        });
      } else {
        wx.updateTimelineShareData({

          title: myPYQtitle, // 分享标题

          desc: '', //分享描述

          link: shareWxLink, // 分享链接

          imgUrl: myPYQimg // 分享图标

        });
        //分享给朋友
        wx.updateAppMessageShareData({

          title: myLTtitle, // 分享标题

          desc: myLTcontent, //分享描述

          link: shareWxLink, // 分享链接

          imgUrl: myLTimg // 分享图标

        });
      }
      //分享到朋友圈
    });

    // })

  }

}